module.exports = __webpack_public_path__ + "map.2e8f7f71e24be2d93356.png";


//////////////////
// WEBPACK FOOTER
// G:/UTL/Alumni/Alumni-ANG/src/assets/img/map.png
// module id = ../../../../../src/assets/img/map.png
// module chunks = styles